export const PROFESSIONAL_STATUSES = {
	ENABLED: 'ENABLED',
	DISABLED: 'FLEX',
	PENDING: 'PENDING',
	TERMINATED: 'TERMINATED'
};

export default PROFESSIONAL_STATUSES;
